export default "__VITE_ASSET__CJ$D3PMV__"